import { writable } from 'svelte/store';

export const currentPath = writable(window.location.pathname);

export function navigateTo(path: string) {
	window.history.pushState({}, '', path);
	currentPath.set(path);
}

// Listen for browser back/forward
window.addEventListener('popstate', () => {
	currentPath.set(window.location.pathname);
});

// Handle link clicks - use event delegation
if (typeof document !== 'undefined') {
	document.addEventListener('click', (e: Event) => {
		const target = e.target as HTMLElement;
		const link = target.closest('a[href^="/"]') as HTMLAnchorElement;

		if (link && !link.target && !link.hasAttribute('download')) {
			const href = link.getAttribute('href');
			if (href && href.startsWith('/')) {
				e.preventDefault();
				e.stopPropagation();
				// Use setTimeout to ensure state updates before rendering
				navigateTo(href);
			}
		}
	});
}
